import React from 'react'
import { separeDataByGroups } from './constants/separeDataByGroups'
import CertificateRow from './components/CertificateRow';
import "./styles/SustainabilityAttributesAccordion.scss"
import { deleteGuion } from './utils';
import { SUSTAINABILITY_ATTRIBUTES } from './constants/attributesByGroups';
import SustainabilityAttrRow from './components/SustainabilityAttrRow';
import { useIntl } from 'react-intl';

const SustainabilityAttributesAccordion = ({ 
  data,
}) => {
  const intl = useIntl();
  const { locale } = intl

  const otherattributes = data?.otherattributes
  const { packagingFsc, sustainability, general, manufacturingCertifications, epds } = data
  const mainDataToShow = 
    separeDataByGroups({
      sustainability,
      manufacturingCertifications,
      packagingFsc,
      general,
      epds,
      locale
    })

  return (
    <section>
      {
        mainDataToShow.map((group) => {
          return <React.Fragment key={`item-${ group.id }`}>
            <table className='border border-2 mt-2 w-100'>
              <tr>
                <td className='font-weight-bold' colSpan={4}>{group.title}</td>
              </tr>
              {group.attrs.map((attr) => {
                if (attr.title === SUSTAINABILITY_ATTRIBUTES[group.title.key]?.antimicrobial || 
                  attr.title === SUSTAINABILITY_ATTRIBUTES[group.title.key]?.biobasedPvcBioAttributed) {
                  attr.value = ""
                  attr.certificateNotExpires = ""
                }

                deleteGuion(attr);
                return <SustainabilityAttrRow
                  key={`item__${attr.id}`}
                  currentAttr={attr}
                  currentGroup={group}
                  certificateDomain={otherattributes?.certificateDomain}
                />
              })}
              {group.areCertificates &&
                <td colSpan={4}>
                  <CertificateRow
                    groupTitle={group.title.key}
                    attrs={group.attrs}
                    link={otherattributes?.certificateDomain}
                  />
                </td>}
            </table>
          </React.Fragment>
        })
      }
    </section>
  )
}

export default SustainabilityAttributesAccordion;